'use client'

import { FixedUpsell } from '@/features/upsell/components/fixed-upsell'
import { PopupReturnCheckoutPage } from '@/features/upsell/components/popup-return-checkout'
import { useSetActivePopupUpsell } from '@/features/upsell/hooks/use-set-active-popup-upsell'
import { useSetTheLatestOrder } from '@/features/upsell/hooks/use-set-the-latest-order'
import { TypePopup, useUpsellStore } from '@/store/upsell'
import { AnimatePresence } from 'framer-motion'

export const GlobalComponents = () => {
  const { type, showFixedPopupUpsell } = useUpsellStore()
  useSetTheLatestOrder()
  useSetActivePopupUpsell()
  return (
    <AnimatePresence>
      {type === TypePopup.PAYMENT && <PopupReturnCheckoutPage />}
      {type === TypePopup.UPSELL && showFixedPopupUpsell && <FixedUpsell />}
    </AnimatePresence>
  )
}
